"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormat = exports.IntegerFormat = exports.StringFormat = void 0;
var StringFormat;
(function (StringFormat) {
    /** @description Standard string format  */
    StringFormat["None"] = "";
    /** @description A single character  */
    StringFormat["Char"] = "char";
    /** @description A base64 string of characters.  Represents a byte array  */
    StringFormat["Byte"] = "byte";
    /**
     * @description Any sequence of octets. (ie, a sequence of unencoded bytes)
     * This may not be used for a parameter or property, as it represents a sequence of bytes,
     * it may only be used as for a request or response body, and must be used with an appropriate content-type
     */
    StringFormat["Binary"] = "binary";
    /** @description A date as defined by full-date - RFC3339 */
    StringFormat["Date"] = "date";
    /** @description A time as defined by ISO 8661 */
    StringFormat["Time"] = "time";
    /** @description A Date-Time as defined by date-time - RFC3339  */
    StringFormat["DateTime"] = "date-time";
    /** @description A hint to UIs to obscure input. */
    StringFormat["Password"] = "password";
    /** @description a A Date-Time as defined by date-time - RFC1123 */
    StringFormat["DateTimeRfc1123"] = "date-time-rfc1123";
    /** @description a A Date-Time as defined by date-time - RFC1123 */
    StringFormat["DateTimeRfc7231"] = "date-time-rfc7231";
    /** @description a duration of time (todo: RFC reference? ) */
    StringFormat["Duration"] = "duration";
    /** @description a Universally Unique Identifier ( ISO/IEC 11578:1996) */
    StringFormat["Uuid"] = "uuid";
    /** @description a base64url string of characters, represented as a byte array (see RFC 4648 ) */
    StringFormat["Base64Url"] = "base64url";
    /**
     * @description a string that should be an URI.
     */
    StringFormat["Uri"] = "uri";
    /**
     * @description a string that should be an URI. Alias of uri
     */
    StringFormat["Url"] = "url";
    /**
     * Represent a Azure Resource Manager Resource ID.
     */
    StringFormat["ArmId"] = "arm-id";
    /** @description an encoded odata query string */
    StringFormat["OData"] = "odata-query";
    StringFormat["Certificate"] = "certificate";
})(StringFormat || (exports.StringFormat = StringFormat = {}));
var IntegerFormat;
(function (IntegerFormat) {
    /** @description an integer value (a javascript representation of maximum safe value is (2^53 - 1). ) */
    IntegerFormat["None"] = "";
    /** @description an explicity declared 32 bit integer */
    IntegerFormat["Int32"] = "int32";
    /** @description an explicity declared 64 bit integer */
    IntegerFormat["Int64"] = "int64";
    /** @description a UnixTime (number of seconds that have elapsed since 00:00:00 Coordinated Universal Time (UTC), Thursday, 1 January 1970) */
    IntegerFormat["UnixTime"] = "unixtime";
})(IntegerFormat || (exports.IntegerFormat = IntegerFormat = {}));
var NumberFormat;
(function (NumberFormat) {
    /** @description - any number */
    NumberFormat["None"] = "";
    /** @description - a 32 bit-precision floating point value */
    NumberFormat["Float"] = "float";
    /** @description - a 64 bit-precision floating point value */
    NumberFormat["Double"] = "double";
    /** @description - a 128 bit-precision floating point value */
    NumberFormat["Decimal"] = "decimal";
})(NumberFormat || (exports.NumberFormat = NumberFormat = {}));
//# sourceMappingURL=formats.js.map